import React from 'react';

const Heading = (props) => {

  return( 
      <h2 className={`font-bold pb-4 text-4xl ${props.className || ''}`}> {props.children} </h2>
  )
}

export default Heading;

